module.exports = __webpack_public_path__ + "static/img/login-boy.2df6c0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login-boy.png
// module id = nGHG
// module chunks = 1